import { FC, MutableRefObject, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Detail from '.';
import { useMethods } from '@lhb/hook';

/**
 * 拓店任务-详情-抽屉
 * @description 拓店任务：加盟+直营A（基诺浦）、加盟+直营B（一鸣）
 */
const ExpansionFranchiseeCircleTaskDrawer:FC<{
  reload?,
  isHistory?: boolean,
  hideOperate?,
  hideClusterDetail?: boolean,
  isLocxx?: boolean,
  onEdit?: (taskId: number | string) => void,
  onClose?: (visible?:boolean)=>void,
  ref?: any,
}> = forwardRef(({
  reload,
  isHistory = false,
  hideOperate,
  hideClusterDetail = false,
  isLocxx = false,
  onEdit,
  onClose,
}, ref) => {
  const [id, setId] = useState(null);
  // const [tab, setTab] = useState(''); // 如果弹出框详情内有 tab，则可以设置 tab
  const [open, setOpen] = useState(false); // 弹出框是否打开
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();

  // const [container, setContainer] = useState<HTMLElement | null>(null);
  // useEffect(() => {
  //   if (open) {
  //     setTimeout(() => {
  //       const target = drawerWrapper.current?.getBodyElement();
  //       target && setContainer(target);
  //     }, 0);
  //   }
  // }, [open]);

  const methods = useMethods({
    init(taskId: number | string) {
      setId(taskId as any);
      // tab && setTab(tab);
      setOpen(true);

      setTimeout(() => {
        drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
        detail.current.init instanceof Function && detail.current.init();
      }, 0);
    },

    onClose() {
      setOpen(false);
      onClose?.();
    },

    handleEdit(taskId: number | string) {
      setOpen(false);
      onClose?.(false);
      onEdit?.(taskId);
    },
  });

  useImperativeHandle(ref, () => ({
    init: methods.init,
  }));

  return (
    <V2Drawer
      onRef={drawerWrapper}
      open={open}
      onClose={methods.onClose}
      maskClosable={false}
      push={false}
      bodyStyle={{ padding: 0, }}
    >
      {open && <Detail
        reload={reload}
        ref={detail}
        isHistory={isHistory}
        hideOperate={hideOperate}
        hideClusterDetail={hideClusterDetail}
        isLocxx={isLocxx}
        // container={container}
        // tab={tab}
        id={id as any}
        // onClose={() => setOpen(false)}
      />}
    </V2Drawer>
  );
});

export default ExpansionFranchiseeCircleTaskDrawer;
